module.exports = __webpack_public_path__ + "img/eye_icon.cd0bcc8f.svg";